import { render, staticRenderFns } from "./phoneEdit.vue?vue&type=template&id=e2221d1c&scoped=true&"
import script from "./phoneEdit.vue?vue&type=script&lang=ts&"
export * from "./phoneEdit.vue?vue&type=script&lang=ts&"
import style0 from "./phoneEdit.vue?vue&type=style&index=0&id=e2221d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2221d1c",
  null
  
)

export default component.exports